import React, { ChangeEvent } from 'react';
import {
  Checkbox,
  Grid
} from 'e100-react-components';
import Icon, { Props as IconProps } from 'components/Icon';

import { Label } from './Label';
import { useStyles } from './styles';

export const CheckboxListItem = ({
  icon,
  iconColor,
  onChange,
  checked,
  value,
  title,
  subtitle,
  labelColor,
  indeterminate = false
}: CheckboxListItemProps) => {
  const classes = useStyles();

  return (
    <Grid
      container
      alignItems="center"
      justify="space-between"
      wrap={'nowrap'}
    >
        { icon && (
          <Grid item classes={{ item: classes.iconContainer }}>
            <Icon kind={icon} style={{ color: iconColor }} color={'secondary'} />
          </Grid>
        ) }
      <Grid item classes={{ item: classes.checkboxContainer }}>
        <Checkbox
          classes={{
            formControlLabel: {
              labelPlacementStart: classes.labelPlacementStart
            },
            checkbox: {
              root: classes.checkboxRoot
            }
          }}
          onChange={onChange}
          isChecked={checked}
          labelPlacement={'start'}
          label={<Label
            title={title}
            subtitle={subtitle}
            labelColor={labelColor}
          />}
          value={value}
          indeterminate={indeterminate && !checked}
        />
      </Grid>
    </Grid>
  );
};
export interface CheckboxListItemProps {
  onChange?: (event: ChangeEvent<Element>, isChecked: boolean) => void;
  icon?: IconProps['kind'];
  iconColor?: string;
  value?: string;
  title?: string;
  subtitle?: string;
  checked?: boolean;
  labelColor?: 'inherit' | 'primary' | 'secondary' | 'default';
  indeterminate?: boolean
};
